/* nxg-v10-product.js - Main Theme V10 (NOMAD phase 3). PRODUCT pages.
   Variant selection, gallery, quantity, cart drawer opening, related products
   and the sticky mobile purchase bar for sections/nxg-product-main.liquid.
   Add to cart itself is the theme's <product-form> (component-product-form.js),
   which posts to /cart/add.js and refreshes the live cart drawer. */
(function () {
  'use strict';

  function qs(el, s) { return el.querySelector(s); }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

  function initMain(root) {
    if (root.dataset.npReady) return;
    root.dataset.npReady = '1';

    var dataEl = qs(root, '[data-np-variants]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var labels = data.labels || {};
    var optCount = data.options || 0;

    var idInput = qs(root, '[data-np-id]');
    var addBtn = qs(root, '[data-np-add]');
    var addText = qs(root, '[data-np-add-text]');
    var form = qs(root, 'product-form form');
    var productForm = qs(root, 'product-form');
    var statusEl = qs(root, '[data-np-status]');
    var bar = qs(root, '[data-np-bar]');
    var barBtn = qs(root, '[data-np-bar-add]');
    var barText = qs(root, '[data-np-bar-text]');
    var barPrice = qs(root, '[data-np-bar-price]');
    var dynamic = qs(root, '[data-np-dynamic]');

    /* ---------- gallery ---------- */
    function showMedia(id) {
      if (!id) return;
      var slide = qs(root, '[data-np-slide="' + id + '"]');
      if (!slide) return;
      qsa(root, '[data-np-slide]').forEach(function (s) {
        var on = s === slide;
        s.hidden = !on;
        s.classList.toggle('is-active', on);
        if (!on) qsa(s, 'video').forEach(function (v) { try { v.pause(); } catch (e) {} });
      });
      qsa(root, '[data-np-thumb]').forEach(function (t) {
        var on = t.getAttribute('data-np-thumb') === String(id);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && t.parentElement) {
          var p = t.parentElement;
          if (p.scrollWidth > p.clientWidth) p.scrollLeft = t.offsetLeft - 20;
          else if (p.scrollHeight > p.clientHeight) p.scrollTop = t.offsetTop - 20;
        }
      });
    }
    qsa(root, '[data-np-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-np-thumb')); });
    });

    /* ---------- quantity ---------- */
    var qty = qs(root, '[data-np-qty-input]');
    qsa(root, '[data-np-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        v = Math.max(1, v + parseInt(b.getAttribute('data-np-qty'), 10));
        qty.value = v;
      });
    });
    if (qty) qty.addEventListener('change', function () {
      var v = parseInt(qty.value, 10);
      if (!v || v < 1) qty.value = 1;
    });

    /* ---------- variants ---------- */
    function selectedOptions() {
      var out = [];
      for (var i = 0; i < optCount; i++) {
        var sel = qs(root, 'select[data-np-option="' + i + '"]');
        if (sel) { out.push(sel.value); continue; }
        var r = qs(root, 'input[data-np-option="' + i + '"]:checked');
        out.push(r ? r.value : null);
      }
      return out;
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function setText(sel, txt) { var el = qs(root, sel); if (el) el.textContent = txt; }
    function toggle(sel, show) { var el = qs(root, sel); if (el) el.hidden = !show; }

    function markValues(opts) {
      qsa(root, 'input[data-np-option]').forEach(function (inp) {
        var i = parseInt(inp.getAttribute('data-np-option'), 10);
        var test = opts.slice(); test[i] = inp.value;
        var v = findVariant(test);
        var lab = inp.nextElementSibling;
        if (!lab) return;
        lab.classList.toggle('is-unavailable', !v);
        lab.classList.toggle('is-soldout', !!v && !v.available);
        var note = qs(lab, '[data-np-note]');
        if (note) note.textContent = !v ? ', unavailable' : (!v.available ? ', sold out' : '');
      });
      qsa(root, 'select[data-np-option]').forEach(function (sel) {
        var i = parseInt(sel.getAttribute('data-np-option'), 10);
        qsa(sel, 'option').forEach(function (o) {
          var test = opts.slice(); test[i] = o.value;
          var v = findVariant(test);
          var base = o.getAttribute('data-np-base') || o.textContent;
          o.setAttribute('data-np-base', base);
          o.textContent = base + (!v ? ' (unavailable)' : (!v.available ? ' (sold out)' : ''));
        });
      });
    }

    /* Variant-specific trust cues (fp30). Only runs when a variant carries its
       own cue metafields (data-np-variant-cues). Every selection change,
       including an unavailable combination, starts a new request sequence and
       aborts the request in flight. While a request is pending, or if it
       fails, the cue slots show the product-level cues (rendered into
       <template data-np-cues-base>), never the previous variant's facts. A
       response is applied only if its sequence number is still current and
       both the selected variant and the variant the server rendered match. */
    var cuesTimer = null, cuesSeq = 0, cuesCtl = null, cuesVid = null;
    var cuesSlots = [['[data-np-cues-wrap]', 'cues'], ['[data-np-more-wrap]', 'more']];
    function cuesBase(part) {
      var t = qs(root, 'template[data-np-cues-base="' + part + '"]');
      return t ? t.innerHTML : '';
    }
    function cuesBusy(on) {
      cuesSlots.forEach(function (p) {
        var el = qs(root, p[0]);
        if (!el) return;
        el.classList.toggle('is-loading', on);
        if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
      });
    }
    function cuesNeutral() {
      cuesSlots.forEach(function (p) {
        var el = qs(root, p[0]);
        if (el) { el.innerHTML = cuesBase(p[1]); el.removeAttribute('data-np-variant-id'); }
      });
    }
    function refreshCues(v) {
      if (!root.hasAttribute('data-np-variant-cues')) return;
      cuesSeq += 1;
      clearTimeout(cuesTimer);
      if (cuesCtl) { try { cuesCtl.abort(); } catch (e) {} cuesCtl = null; }
      cuesVid = v ? String(v.id) : null;
      cuesNeutral();
      if (!v) { cuesBusy(false); return; }
      cuesBusy(true);
      var seq = cuesSeq, vid = cuesVid;
      cuesTimer = setTimeout(function () {
        var ctl = typeof AbortController === 'function' ? new AbortController() : null;
        cuesCtl = ctl;
        var url = root.getAttribute('data-product-url') + '?variant=' + encodeURIComponent(vid) + '&section_id=' + encodeURIComponent(root.getAttribute('data-section-id'));
        fetch(url, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        }).then(function (html) {
          if (seq !== cuesSeq || vid !== cuesVid) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = cuesSlots.map(function (p) { return doc.querySelector(p[0]); });
          if (!fresh[0] || fresh[0].getAttribute('data-np-variant-id') !== vid) throw new Error('variant mismatch');
          cuesSlots.forEach(function (p, i) {
            var cur = qs(root, p[0]);
            if (cur && fresh[i]) { cur.innerHTML = fresh[i].innerHTML; cur.setAttribute('data-np-variant-id', vid); }
          });
          if (cuesCtl === ctl) cuesCtl = null;
          cuesBusy(false);
        }).catch(function () {
          if (seq !== cuesSeq) return;
          if (cuesCtl === ctl) cuesCtl = null;
          cuesNeutral();
          cuesBusy(false);
        });
      }, 150);
    }

    function render(v, opts, announce) {
      for (var i = 0; i < opts.length; i++) {
        var chosen = qs(root, '[data-np-chosen="' + i + '"]');
        if (chosen) chosen.textContent = opts[i] || '';
      }
      markValues(opts);

      var label, disabled;
      if (!v) { label = labels.unavailable || 'Unavailable'; disabled = true; }
      else if (!v.available) { label = labels.soldout || 'Sold out'; disabled = true; }
      else if (v.preorder) { label = labels.preorder || 'Pre-order'; disabled = false; }
      else { label = labels.add || 'Add to cart'; disabled = false; }

      addBtn.disabled = disabled;
      addText.textContent = label;
      if (barBtn) { barBtn.disabled = disabled; barText.textContent = label; }
      if (dynamic) dynamic.hidden = disabled;

      if (v) {
        idInput.value = v.id;
        setText('[data-np-now]', v.price);
        if (barPrice) barPrice.textContent = v.price;
        var sale = !!v.compare;
        toggle('[data-np-was]', sale);
        toggle('[data-np-save]', sale);
        toggle('[data-np-badge-wrap]', sale);
        if (sale) {
          setText('[data-np-was-val]', v.compare);
          setText('[data-np-save-val]', v.save);
          setText('[data-np-badge]', v.pct >= 1 ? 'Save ' + v.pct + '%' : 'On sale');
        }
        setText('[data-np-sku]', v.sku || '');
        toggle('[data-np-sku-row]', !!v.sku);
        if (v.media) showMedia(v.media);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', u.toString());
        } catch (e) {}
        refreshCues(v);
      }
      if (!v) refreshCues(null);
      if (announce && statusEl) {
        statusEl.textContent = (opts.filter(Boolean).join(', ')) + '. ' + (v ? v.price + '. ' : '') + label + '.';
      }
    }

    qsa(root, '[data-np-option]').forEach(function (el) {
      el.addEventListener('change', function () {
        var opts = selectedOptions();
        render(findVariant(opts), opts, true);
      });
    });
    if (optCount > 0 && qs(root, '[data-np-option]')) {
      var o0 = selectedOptions();
      markValues(o0);
    }
    /* Back/forward (fp30): if the browser restored option inputs that no
       longer match the rendered variant, re-render from the visible choice so
       the price, SKU, cues and cart id agree. */
    window.addEventListener('pageshow', function () {
      if (!(optCount > 0 && qs(root, '[data-np-option]'))) return;
      var o = selectedOptions(), v = findVariant(o);
      if (v && String(v.id) !== String(idInput.value)) render(v, o, false);
    });

    /* ---------- cart drawer ---------- */
    if (productForm) {
      productForm.addEventListener('add-to-cart', function () {
        var sb = document.getElementById('site-cart-sidebar');
        if (sb && typeof sb.show === 'function') sb.show();
        var cr = document.getElementById('cart-recommendations');
        if (cr && typeof cr.generateRecommendations === 'function') cr.generateRecommendations();
        if (statusEl) statusEl.textContent = 'Added to cart.';
      });
      /* mirror the theme's loading class onto the sticky bar button */
      new MutationObserver(function () {
        var busy = addBtn.classList.contains('working');
        addBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (barBtn) barBtn.classList.toggle('working', busy);
      }).observe(addBtn, { attributes: true, attributeFilter: ['class'] });
    }

    /* ---------- sticky mobile purchase bar ---------- */
    if (bar && barBtn) {
      bar.hidden = false;
      var mq = window.matchMedia('(max-width: 749px)');
      var buyRow = qs(root, '.np-buy');
      var footer = document.querySelector('footer');
      var ticking = false;
      /* Measured on scroll rather than by IntersectionObserver alone: a fast
         jump past the buy row never intersects, so an observer would miss it. */
      function update() {
        ticking = false;
        var r = buyRow.getBoundingClientRect();
        var buyAbove = r.bottom < 0;
        var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        var show = mq.matches && buyAbove && !footerVisible;
        if (show === bar.classList.contains('is-visible')) return;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        barBtn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('np-bar-on', show);
      }
      function schedule() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(schedule, { threshold: 0 });
        io.observe(buyRow);
        if (footer) io.observe(footer);
      }
      update();
      if (mq.addEventListener) mq.addEventListener('change', update);
      barBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(addBtn);
        else addBtn.click();
      });
    }
  }

  function initRelated(sec) {
    if (sec.dataset.npReady) return;
    sec.dataset.npReady = '1';
    var grid = sec.querySelector('[data-np-related-grid]');
    if (grid && grid.children.length) { sec.hidden = false; return; }
    var url = sec.getAttribute('data-url');
    if (!url) return;
    function load() {
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-np-related-grid]');
        if (fresh && fresh.children.length) {
          grid.innerHTML = fresh.innerHTML;
          sec.hidden = false;
        } else {
          sec.remove();
        }
      }).catch(function () {});
    }
    load();
  }

  function boot() {
    qsa(document, '[data-np-root]').forEach(initMain);
    qsa(document, '[data-np-related]').forEach(initRelated);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
